
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'


import headerBackTitle from '@/components/header/headerBackTitle'
import listItem from '@/components/donateTogether/listItem'
export default {
components:{
listItem,
headerBackTitle,
Tab,
TabItem
},
data() {
return {
histroy: false,
typeIndex: 0,
listTab: ['进行中', '已完成'],
activeTab: '进行中',
queryState: 1,//查询状态 1是进行中，2是已完成
isFirst: true, //是否第一次切换
finishList: [], //已完成数据
unfinishList: [], //进行中数据
sortIndex:1,
epId:this.$route.params.epId,
listTotal:''
}
},
computed: {



},
methods: {
tabSwitch(index,item) {
this.activeTab = item
this.typeIndex = index
if(index==0) {
this.queryState = 1;
}else {
this.queryState = 2;
}
if(this.isFirst) {
this.isFirst = false
this.getList()
}
},





refresh (done) {
setTimeout(() => {
this.sortIndex = 1
if(this.queryState == 1){
this.unfinishList = []
}else {
this.finishList = []
}
this.getList();
done()
}, 1000)








},
infinite (done) {
setTimeout(() => {
if(this.queryState == 1){
if(this.unfinishList.length < this.listTotal) {
this.sortIndex++
this.getList(done);
}else {
done(true)
}
}else {
if(this.finishList.length < this.listTotal) {
this.sortIndex++
this.getList(done);
}else {
done(true)
}

}

}, 1000)
},
getList(done) {
let data = {
epId: this.epId,
finished: this.queryState,
pageIndex:this.sortIndex,
pageSize: 10
}
this.$https.post(this.BASE_URL+"grd/groupDonation/listOfGroupDonationByCreatorID",
data
)
.then(res => {
this.listTotal = res.data.data.total
if(this.queryState === 1) {

this.unfinishList.push(...res.data.data.records)
}else {

this.finishList.push(...res.data.data.records)
}
if(done){
done(true)
}
})
.catch(function(err) {
console.log(err);
})
}
},
created() {
if(this.$route.query.histroy){
this.histroy=true
}
this.getList()
this.L("zcuserid",this.$route.params.userId)
this.L("zctoken",this.$route.params.token)
this.L("zcnickname",this.$route.params.nickName)
}
}



// WEBPACK FOOTER //
// ./src/crowd_fund/dTList.vue